const fixSliderFocus = () => {
  // Handle hidden slides
  const hiddenSlides = document.querySelectorAll('.splide__slide[aria-hidden="true"]');
  hiddenSlides.forEach(slide => {
    slide.querySelectorAll('a, button').forEach(el => {
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-hidden', 'true'); // Add this line
    });
  });

  // Handle visible slides
  const visibleSlides = document.querySelectorAll('.splide__slide:not([aria-hidden="true"])');
  visibleSlides.forEach(slide => {
    slide.querySelectorAll('a, button').forEach(el => {
      el.setAttribute('tabindex', '0');
      el.removeAttribute('aria-hidden'); // Add this line
    });
  });
};

// Keep the same event listeners as before
document.addEventListener('DOMContentLoaded', fixSliderFocus);
window.addEventListener('scroll', fixSliderFocus);
document.addEventListener('click', (e) => {
  if (e.target.closest('.splide__arrow') || e.target.closest('.splide__pagination')) {
    setTimeout(fixSliderFocus, 500);
  }
});